export default __webpack_public_path__ + "static/media/store.117c9c8a.svg";